import { Api } from 'models/services/api';
import { UpdateDishItemQuery } from 'models/services/graphql';

import { DishItemEditorDataToUpdate } from '../editor';
import { DishItemDataToRevise } from '../dish-item';

type DataToFetch = {
  id: string;
  input: DishItemEditorDataToUpdate;
};

const RequestQuery = `
  mutation UpdateDishItem($id: ID!, $input: UpdateDishItemInput!) {
    ${UpdateDishItemQuery}
  }
`;

type ResponseData = {
  data: {
    updateDishItem: DishItemDataToRevise;
  };
};

class UpdateGql {

  readonly api: Api<ResponseData>;
  readonly document?: DishItemDataToRevise;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToFetch): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.updateDishItem;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { UpdateGql };
export type { DataToFetch as UpdateGqlDataToFetch }
